export default __webpack_public_path__ + "static/media/news-small-homepage-3.58990d5b.png";